export default __webpack_public_path__ + "static/media/btc.4c31baf4.svg";